import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetUsersAction } from '../../actions/users/get-users-action';
import { GetUsersSuccessAction } from '../../actions/users/get-users-success-action';
import { GetUsersErrorAction } from '../../actions/users/get-users-error-action';

@Injectable()
export class GetUsersEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetUsersActions = createEffect(() => this.actions
    .pipe(
      ofType(GetUsersAction.type),
      mergeMap(action => {
        const getUsersAction = <GetUsersAction>action;
        return this.api.getUsers(getUsersAction.bijbEvent).then(users => {
          return new GetUsersSuccessAction(users);
        }, error => {
          return new GetUsersErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
